import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _get from "lodash/get";
import _groupBy from "lodash/groupBy";
import _isNil from "lodash/isNil";
import _map from "lodash/map";
import _flatMap from "lodash/flatMap";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { ControlBar } from '@datacamp/campus-integration';
import { sct, solution } from '@datacamp/drag-and-drop-exercise-core';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { sentry } from '../../lib/sentry';
import { jsx as ___EmotionJSX } from "@emotion/react";
const basicErrorHandling = (fn, setError) => () => {
  try {
    fn();
  } catch (error) {
    sentry.captureError(error);
    // @ts-expect-error fix later
    setError(error);
  }
};
const ActionBar = _ref => {
  let {
    checkExercise,
    disabled,
    groupedItems,
    initialGroupedItems,
    itemsSolution,
    scts,
    setError,
    setGroupedItems
  } = _ref;
  const {
    t
  } = useTranslation();
  const onReset = React.useCallback(() => {
    setGroupedItems(initialGroupedItems);
  }, [initialGroupedItems, setGroupedItems]);
  const onSubmit = React.useCallback(basicErrorHandling(() => {
    const flattenedItems = _flatMap(groupedItems, (items, target) => _map(items, (item, index) => _objectSpread(_objectSpread({}, item), {}, {
      index,
      offset: _isNil(item.offset) ? 0 : item.offset,
      target
    })));
    const flattenedItemsSolution = _flatMap(_groupBy(itemsSolution, 'target'), (items, target) => _map(items, (item, index) => _objectSpread(_objectSpread({}, item), {}, {
      index,
      offset: _isNil(item.offset) ? 0 : item.offset,
      target
    })));
    const {
      feedbackMessage,
      isCorrect,
      item: feedbackItem
    } = sct(scts, flattenedItems, flattenedItemsSolution);
    const newItems = solution.updateItemsStatus(flattenedItems, flattenedItemsSolution, scts.isOrdered).map(item => _objectSpread(_objectSpread({}, item), {}, {
      highlight: item.id === _get(feedbackItem, 'id')
    }));
    const newGroupedItems = _groupBy(newItems, 'target');
    if (isCorrect) {
      checkExercise(_isNil(scts.successMessage) ? 'Good job!' : scts.successMessage, true, newGroupedItems);
    } else if (!_isNil(feedbackMessage)) {
      checkExercise(feedbackMessage, false, newGroupedItems);
    } else if (!_isNil(scts.failureMessage)) {
      checkExercise(scts.failureMessage, false, newGroupedItems);
    }
  }, setError), [groupedItems, itemsSolution]);
  return ___EmotionJSX(ControlBar, {
    className: "dc-u-bgc-grey-100",
    disabled: disabled,
    loading: false,
    onReset: onReset,
    onSubmit: onSubmit,
    submitLabel: t('ActionBar.submitButton')
  });
};
export default ActionBar;